jQuery($ => {
    class SearchToggle {
      constructor(element) {
        this._        = element;
        this._element = $(element);
        this._trigger = this._element.find('.m-meganav-toggle__trigger-input');
        this._content = this._element.find('.m-meganav-toggle__content');
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );

        // Add "inert" attribute to the content
        // We only want this if JS is available
        this._content.attr('inert', '');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Utility functions
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      calculatePosition = () => {
        // If content is not visible, don't calculate position
        if (!this._content.is(':visible')) {
          return;
        }

        // If on mobile sizes (< 1025px), remove left style
        if (window.innerWidth < 1025) {
          this._content[0].style.left = '';
          return;
        }

        const triggerRect = this._trigger[0].getBoundingClientRect();
        const contentRect = this._content[0].getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const containerPadding = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--container-padding'));
        const contentWidth = contentRect.width;
        const contentWidthWithMargin =contentRect.width + containerPadding;

        // Position the center of the content at the center of the trigger
        // Considering content has translateX(-50%) applied to it
        let leftPosition = triggerRect.left + triggerRect.width / 2;        

        // Check if content won't overflow the viewport to the left
        const newContentLeft = leftPosition - contentWidthWithMargin / 2;
        if (newContentLeft < 0) {
          // Reposition to make it fit the viewport
          leftPosition += newContentLeft * -1;
        }

        // Check if content won't overflow the viewport to the right
        const newContentRight = leftPosition + (contentWidth / 2) + (containerPadding * 2);
        if (newContentRight > viewportWidth) {
          // Reposition to make it fit the viewport
          leftPosition -= newContentRight - viewportWidth;
        }

        this._content[0].style.left = `${leftPosition - triggerRect.left}px`;
      }

      handleClickOutside = (e) => {
        const target = $(e.target);
        // Check if target is within this._element
        if (!target.closest(this._element).length) {
          this.handleClose(true);
        };
      }

      handleToggle(e) {
        if (e.target.checked) {
          this.handleOpen(true);
        } else {
          this.handleClose(true);
        }
      }

      handleOpen() {
        // If trigger is still unchecked, check it
        if (!this._trigger.prop('checked')) {
          this._trigger.prop('checked', true);
        }

        this._element.addClass('m-meganav-toggle--open');

        // Remove the "inert" attribute from the content
        this._content.removeAttr('inert');

        this.calculatePosition();

        // Does the content have any m-meganav-menu__main-menu-back-button?
        // If so, let's add a click event to it
        const backButton = this._content.find('.m-meganav-menu__main-menu-back-button');
        if (backButton.length) {
          backButton.on('click', () => {
            this.handleClose();
          });
        }

        const parentItem = this._element.closest('.m-header-bottom-nav__item');
        if (parentItem.length) {
          parentItem.addClass('m-header-bottom-nav__item--open');
        }
        const parentNav = this._element.closest('.m-header-bottom-nav');
        if (parentNav.length) {
          parentNav.addClass('m-header-bottom-nav--open');
        }

        setTimeout(() => {
          $('body').on('click', this.handleClickOutside);
        }, 0);
      }

      handleClose() {
        this.unregisterClickOutside();
        this._element.removeClass('m-meganav-toggle--open');

        const parentItem = this._element.closest('.m-header-bottom-nav__item');
        if (parentItem.length) {
          parentItem.removeClass('m-header-bottom-nav__item--open');
        }
        const parentNav = this._element.closest('.m-header-bottom-nav');
        if (parentNav.length) {
          parentNav.removeClass('m-header-bottom-nav--open');
        }

        // Add "inert" attribute to the content
        this._content.attr('inert', '');
        
        // If trigger is still checked, uncheck it
        if (this._trigger.prop('checked')) {
          this._trigger.prop('checked', false);
        }
      }

      unregisterClickOutside() {
        $('body').off('click', this.handleClickOutside);
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._trigger.on('change', (e) => this.handleToggle(e));

        $(window).on('resize', () => {
          this.calculatePosition();
        });
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.search_toggle = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].search_toggle = new SearchToggle(_[i], opt);
        else
          ret = _[i].search_toggle[opt].apply(_[i].search_toggle, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-meganav-toggle').search_toggle();
});